
/* Pages produits : parfum choisi (The Real Shake), état des deux restaurants à l'heure de Paris (soirs de match à Lens
   compris), fin rouge. */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function q(s, r){ return (r || document).querySelector(s); }
  function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---- Choisissez votre parfum ---- */
  var chips = qa('[data-flavor]'), pick = q('[data-pick]');
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      var on = c.getAttribute('aria-pressed') !== 'true';
      chips.forEach(function(x){ x.setAttribute('aria-pressed', 'false'); });
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!pick) return;
      pick.innerHTML = '';
      if (on){ pick.appendChild(document.createTextNode('Votre Real Shake : ')); var b = document.createElement('b'); b.textContent = c.getAttribute('data-flavor'); pick.appendChild(b); pick.appendChild(document.createTextNode(', 100 % crème glacée, chantilly nature.')); }
      else pick.textContent = 'Touchez un parfum : votre Real Shake se compose ici.';
    });
  });

  /* ---- État des restaurants ---- */
  var fmt = null;
  try { fmt = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'}); } catch(e){}
  function minutes(){ var d = new Date(); if (fmt){ var p = {}; fmt.formatToParts(d).forEach(function(x){ p[x.type] = x.value; }); return +p.hour * 60 + +p.minute; } return d.getHours() * 60 + d.getMinutes(); }
  function label(c){ c = c % 1440; return c === 0 ? 'minuit' : Math.floor(c / 60) + 'h' + (c % 60 ? ('0' + c % 60).slice(-2) : ''); }
  function state(key){
    var t = minutes(), open = window.woodysOpen ? woodysOpen(key) : 690, close = 1380, late = (key === 'lens' && window.woodysLate) ? window.woodysLate() : null;
    if (late && late.yesterday && t < late.yesterday - 1440){ var e = late.yesterday - 1440; return {c: e - t <= 30 ? 'is-soon' : 'is-open', txt: (e - t <= 30 ? 'Ferme bientôt · ' : 'Ouvert · jusqu’à ') + label(late.yesterday)}; }
    if (late && late.today) close = late.today;
    if (t >= open && t < close) return {c: close - t <= 30 ? 'is-soon' : 'is-open', txt: (close - t <= 30 ? 'Ferme bientôt · ' : 'Ouvert · jusqu’à ') + label(close)};
    return {c: 'is-closed', txt: t < open ? 'Fermé · ouvre à ' + label(open) : 'Fermé · ouvre demain ' + label(window.woodysOpen ? woodysOpen(key, 1) : 690)};
  }
  var cards = qa('[data-resto]');
  var paint = function(){
    cards.forEach(function(card){
      var s = state(card.getAttribute('data-resto')), el = q('[data-state]', card), tx = q('[data-state-t]', el);
      el.classList.remove('is-open', 'is-soon', 'is-closed'); el.classList.add(s.c);
      if (tx.textContent !== s.txt) tx.textContent = s.txt;
    });
  };
  if (cards.length){ paint(); setInterval(paint, 60000); }

  /* ---- Fin rouge ---- */
  var end = q('[data-end]');
  if (end){
    end.classList.add('js');
    if (!reduce && 'IntersectionObserver' in window){ var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ end.classList.add('in'); io.disconnect(); } }); }, {threshold: .25}); io.observe(end); }
    else end.classList.add('in');
  }
})();

